module.exports = __webpack_public_path__ + "static/media/Hospitality_25.9f065749.jpg";